import React from "react";

function Footer() {

	return (
		<footer>
			<div className="pagesize">
				<p className="link">
					<a href={require("./pdf/service_contract.pdf").default} chartset="UTF-8" target="_blank" rel="noreferrer">服務條款</a> |
					<a href="https://www.hinet.net/copyright.html" target="_blank" rel="noreferrer">著作權保護</a> |
					<a href="https://www.hinet.net/privacy.html" target="_blank" rel="noreferrer">隱私權說明</a> |
					<a href="https://www.cht.com.tw/home/cht/sustainability/sustainability-management/csr-vision" target="_blank" rel="noreferrer">企業社會責任</a> |
					<a href="https://www.hinet.net/kid.html" target="_blank" rel="noreferrer">兒童網路安全</a> |
					<a href="https://www.hinet.net/app/ad_normal.html" target="_blank" rel="noreferrer">刊登廣告</a> |
					<a href="https://www.cht.com.tw/home/cht/recruit-and-training/recruit/recruit-information" target="_blank" rel="noreferrer">人才招募</a> |
					<a href="http://service.hinet.net/2004/ncsc/index.htm" target="_blank" rel="noreferrer">聯絡我們</a>
				</p>
				<p>客服專線：0800-080-123 (中華市話、行動直撥123)</p>
				<p>中華電信個人家庭分公司版權所有 © 2023 Chunghwa Telecom Co., Ltd., Consumer Business Group All Rights Reserved. 統一編號：96979949 </p>
			</div>
		</footer>
	)
}


export default Footer;